import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBanner = () => {
  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-accent/10 border-b border-accent/20 backdrop-blur-sm">
      <div className="flex items-center justify-center px-4 py-3">
        <div className="flex items-center space-x-3">
          <div className="w-6 h-6 bg-accent/20 rounded-full flex items-center justify-center">
            <Icon name="Shield" size={14} color="var(--color-accent)" />
          </div>
          <span className="text-sm font-medium text-accent">
            Secure View-Only Preview • Protected Design Assets
          </span>
          <div className="hidden sm:flex items-center space-x-2 text-xs text-accent/80">
            <Icon name="Lock" size={12} />
            <span>SSL Encrypted</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityBanner;